module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABTUlEQVQ4T63UvS9DURjH8e9za5CwGISJ9N6FxG7Re+9iIdWI2M0d/AM2CavJX4GEIDpJL7FYrb0aA4uQbl6ifaQNeivuy5Ge8eTJ5zznl+ccoc9LfrzzcJGcHMT6gqA0gGGUNXx776/aLhiECyCn8Q1LgJf3CcJ9kBKWFCnkK7/rDUC9wnPmCG4PgRLwguDj2tdR9D/gEbD0hTRAXTzn5hs1B6v1dSyd6QAqQ6Dz8D6LN1VvbxmAXODZXk9ml3cjtJrPiCzj5ttRGIFvwCOq3SaQHMI4lhYpOCemYPwAZAA/gGbyzGsOZKBTkwqqbjL6upUIPg2WUdnJCFIBOUNakbwivFqKqAusZANN33fqleEBuE9xx4CJbB0qG/j2diJYDcuI7GYDoYZIrXfmIryIojoJTGcFzVLMkGEfwLQPNukIZRXfPu59emY9xVZ/AjhwmhVvan+NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dingdan/tabbar_icon_contract_sel.png
// module id = IeJx
// module chunks = 1